import React from 'react';
import styled from 'astroturf/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import _Button from "CloseButton-Button.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/utils/components/CloseButton.tsx?styleId=Button";


type Props = {
  bottom?: number;
  // Allows external styling
  className?: string;
  // Will use rgba(0, 0, 0, 0.6) instead of rgba(255, 255, 255, 0.6)
  dark?: boolean;
  left?: number;
  right?: number;
  top?: number;
  onClick?: () => void;
};

const Button = /*#__PURE__*/styled("button", null, {
  displayName: "Button",
  styles: _Button
});

const CloseButton = ({
  bottom,
  className,
  dark,
  left,
  right,
  top,
  onClick,
  ...rest
}: Props) => (
  <Button
    className={className}
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    dark={dark}
    style={{ bottom, left, right, top }}
    onClick={onClick}
    {...rest}
  >
    <FontAwesomeIcon icon={faTimes} />
  </Button>
);

export default CloseButton;
